import { TicketStatusCombinedProps } from './types';

const usePresenter = (props: TicketStatusCombinedProps): TicketStatusCombinedProps => {
  return props;
};

export default usePresenter;
